<div class="playlist-folder">
  <div *ngFor="let family of playlistsFamilies; let isFirst = first" [class.margin-top-12]="!isFirst">
    <label class="playlist-folder-family-title">{{ family.name }}</label>
    <div *ngFor="let playlist of family.events" class="playlist-folder-event-container">
      <div [style.background-color]="playlist.color" class="playlist-folder-playlist-color"></div>
      <div (click)="selectPlaylistForSlot(playlist)"
           [ngStyle]="activeSlot.event?.id != undefined && activeSlot.event.id === playlist.id ? {'color': '#FF5353'} : {}"
           class="playlist-folder-playlist-infos">
        <label
          class="playlist-folder-small-font">{{ playlist.name }}</label>
        <label class="playlist-folder-small-font">{{ playlist.tracks }} {{ 'blacklist.songs' | translate }}
          — {{ playlist.duration | duration: 'hh:mm': true }}</label>
      </div>
    </div>
  </div>
  <div *ngFor="let playrule of playrules" class="playlist-folder-event-container">
    <div [style.background-color]="playrule.color" class="playlist-folder-playlist-color"></div>
    <div (click)="selectPlayruleForSlot(playrule)" class="playlist-folder-playlist-infos">
      <label
        [ngStyle]="activeSlot.tempo?.id != undefined && activeSlot.tempo.id === playrule.id ? {'color': '#FF5353'} : {}"
        class="playlist-folder-small-font">{{ playrule.name }}</label>
    </div>
  </div>
</div>
